import { z } from 'zod';

export const milestoneCreateSchema = z.object({
  occurred_at: z.number().int().optional(),
  kind: z.string().min(1).max(64),
  title: z.string().min(1).max(120),
  notes: z.string().max(2000).nullable().optional(),
});

export const milestonePatchSchema = milestoneCreateSchema.partial();

export type MilestoneCreateInput = z.infer<typeof milestoneCreateSchema>;
export type MilestonePatchInput = z.infer<typeof milestonePatchSchema>;
